var _ellipse, _ellipse2, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearnInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5,
    cy: 24.9682,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_9473_127995)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4998,
    cy: 24.9678,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_9473_127995)",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5005,
    cy: 12.5,
    r: 11,
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3405 7.08279C14.8875 6.44353 13.3088 6.58082 12.0095 7.45847C10.7518 8.30809 10.0005 9.70723 10.0005 11.2007C10.0005 12.7382 10.6112 13.5463 11.2018 14.3278C11.7125 15.0033 12.1944 15.6415 12.3616 16.7912C12.4353 17.301 12.8761 17.6855 13.386 17.6855H15.6007C16.1183 17.6855 16.5659 17.2978 16.6421 16.7834C16.81 15.6383 17.2912 15.0019 17.8008 14.3278C18.3412 13.6127 18.8997 12.8734 18.9893 11.5718C19.1223 9.64124 18.0577 7.83734 16.3405 7.08279Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7148 12.1855H21.2862C21.1282 12.1855 21.0005 12.0738 21.0005 11.9355C21.0005 11.7973 21.1282 11.6855 21.2862 11.6855H22.7148C22.8728 11.6855 23.0005 11.7973 23.0005 11.9355C23.0005 12.0738 22.8728 12.1855 22.7148 12.1855Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7505 20.6855H14.2505C13.5612 20.6855 13.0005 19.7883 13.0005 18.6855V17.0855C13.0005 16.8643 13.1122 16.6855 13.2505 16.6855C13.3887 16.6855 13.5005 16.8643 13.5005 17.0855V18.6855C13.5005 19.3471 13.837 19.8855 14.2505 19.8855H14.7505C15.164 19.8855 15.5005 19.3471 15.5005 18.6855V17.0855C15.5005 16.8643 15.6122 16.6855 15.7505 16.6855C15.8887 16.6855 16.0005 16.8643 16.0005 17.0855V18.6855C16.0005 19.7883 15.4397 20.6855 14.7505 20.6855Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3406 7.68555C19.2414 7.68555 19.1435 7.63618 19.0762 7.54135C18.958 7.3746 18.9808 7.12973 19.1265 6.99486L20.447 5.77207C20.5928 5.63681 20.8065 5.66324 20.9247 5.8296C21.043 5.99634 21.0202 6.24121 20.8744 6.37608L19.554 7.59887C19.4915 7.65717 19.4157 7.68555 19.3406 7.68555Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6603 16.6855C20.5852 16.6855 20.5098 16.6572 20.4469 16.5989L19.1266 15.376C18.9805 15.2407 18.9581 14.9958 19.0763 14.8294C19.1946 14.6631 19.4086 14.637 19.554 14.7719L20.8744 15.9948C21.0204 16.1301 21.0429 16.375 20.9246 16.5413C20.8574 16.6362 20.7595 16.6855 20.6603 16.6855Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6603 7.68555C9.58522 7.68555 9.50979 7.65717 9.44693 7.59887L8.12663 6.37613C7.98053 6.24087 7.9581 5.99601 8.07634 5.82967C8.19458 5.66332 8.40829 5.63689 8.55404 5.77175L9.87435 6.9945C10.0204 7.12975 10.0429 7.37461 9.92464 7.54096C9.85736 7.63619 9.75951 7.68555 9.6603 7.68555Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3406 16.6855C8.24138 16.6855 8.14352 16.6362 8.07624 16.5413C7.95799 16.3746 7.98076 16.1297 8.12653 15.9948L9.44698 14.7719C9.59275 14.637 9.80649 14.6631 9.92474 14.8294C10.043 14.9962 10.0202 15.2411 9.87445 15.376L8.554 16.5989C8.49113 16.6572 8.41536 16.6855 8.3406 16.6855Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71477 12.1855H6.2862C6.1282 12.1855 6.00049 12.0738 6.00049 11.9355C6.00049 11.7973 6.1282 11.6855 6.2862 11.6855H7.71477C7.87277 11.6855 8.00049 11.7973 8.00049 11.9355C8.00049 12.0738 7.87277 12.1855 7.71477 12.1855Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9473_127995",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5 24.9682) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9473_127995",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4998 24.9678) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnInactive);
export default __webpack_public_path__ + "static/media/learn-inactive.d150954c717c43b551e92e16e6aac2df.svg";
export { ForwardRef as ReactComponent };